import React from 'react';

export default function HelpText({ children }) {
    return <div className="text-muted small">{children}</div>;
}
